import { InversionContainer } from '@/controller/container'
import { InjectionTokens } from '@/controller/tokens'

import { UniqueEntityID } from '@/domain/core'
import { UseCase } from '@/domain/core/UseCase'
import { UserChart } from '@/domain/models/UserChart'
import { Result } from '@/domain/protocols/Result'

import type { IUserChartRepository } from '@/data/UserChartRepository/IUserChartRepository'

export class UpdateUserChartUseCase implements UseCase<UserChart, Promise<Result<UniqueEntityID>>> {
  private repository: IUserChartRepository

  constructor(repository?: IUserChartRepository) {
    if (repository) {
      this.repository = repository
      return
    }
    const container = InversionContainer.getInstance().getContainer()
    this.repository = container.get<IUserChartRepository>(InjectionTokens.UserChartRepository)
  }

  async execute(chart: UserChart): Promise<Result<UniqueEntityID>> {
    try {
      const result = await this.repository.updateChart(chart)
      if (result.isFailure) return Result.fail(result.error)
      return Result.ok(chart.id)
    } catch (error) {
      return Result.fail(error)
    }
  }
}
